import React, { useState } from 'react';
import './style.scss';
import { ModalPopup } from '../ModalPopup/ModalPopup';
import { DATECONTROL_TYPE, WAITER_TYPES } from '../../../utils/enums';
import Waiter from '../Waiter/Waiter';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { getWeekPeriod, prepareMonth, preparePreviousMonth, prepareToday, prepareYesterday } from '../../../utils/convertTime';
import OrderDatetimeControl from '../OrderDatetimeControl';

const ReportModalDateRange = ({ isOpen, setIsOpen, onSave }) => {
    const { t } = useTranslation();

    const getIniDate = () => {
        const start = new Date();
        start.setDate(start.getDate() - 1);
        return start.toString();
    };
    const [startDate, setStartDate] = useState(getIniDate());
    const [endDate, setEndDate] = useState(new Date().toString());

    const handleOnSaveReport = () => {
        onSave({startDate, endDate});
        setIsOpen(false);
    }

    const setTodayDate = () => {
        const { from, to } = prepareToday();
        setStartDate(from);
        setEndDate(to);
    };

    const setYesterdayDate = () => {
        const { from, to } = prepareYesterday();
        setStartDate(from);
        setEndDate(to);
    };

    const setWeekDate = () => {
        const { from, to } = getWeekPeriod();
        setStartDate(from);
        setEndDate(to);
    };

    const setMonthDate = () => {
        const { from, to } = prepareMonth();
        setStartDate(from);
        setEndDate(to);
    };

    const setPreviousMonthDate = () => {
        const { from, to } = preparePreviousMonth();
        setStartDate(from);
        setEndDate(to);
    };

    return (
        <ModalPopup
            width={"420px"}
            height={"300px"}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            content={
                <div className='popupContainer'>
                    <div className='saveReportContainer'>
                        <div className={classNames("containerHeader")}>
                            <div className={classNames("title")}>
                                {t("dialogs.saveReport.SAVE_REPORT_LABEL")}
                            </div>
                            <div className={classNames("link")} onClick={() => setIsOpen(false)}>
                                {t("basic.CLOSE_BUTTON")}
                            </div>
                        </div>

                        <div className={classNames("containerContent")}>
                            <div className={classNames("item")}>
                                <div className="links">
                                    <div className="link" onClick={setTodayDate}>
                                        {t("shifts.TODAY_LINK")}
                                    </div>
                                    <div className="link" onClick={setYesterdayDate}>
                                        {t("shifts.YESTERDAY_LINK")}
                                    </div>
                                    <div className="link" onClick={setWeekDate}>
                                        {t("shifts.WEEK_LINK")}
                                    </div>
                                    <div className="link" onClick={setMonthDate}>
                                        {t("shifts.MONTH_LINK")}
                                    </div>
                                    <div className="link" onClick={setPreviousMonthDate}>
                                        {t("shifts.PREVIOUS_MONTH_LINK")}
                                    </div>
                                </div>
                            </div>
                            <div className={classNames("item")}>
                                <div className={classNames("centerSide")}>
                                    <OrderDatetimeControl
                                        tab={1}
                                        time={new Date(startDate)}
                                        type={DATECONTROL_TYPE.datetime}
                                        isEditable={true}
                                        hideIcon={true}
                                        label={t("dialogs.saveReport.START_DATE_LABEL")}
                                        onSelect={date => setStartDate(date)}
                                    />
                                </div>
                            </div>
                            <div className={classNames("item")}>
                                <div className={classNames("centerSide")}>
                                    <OrderDatetimeControl
                                        tab={1}
                                        time={new Date(endDate)}
                                        type={DATECONTROL_TYPE.datetime}
                                        isEditable={true}
                                        hideIcon={true}
                                        label={t("dialogs.saveReport.END_DATE_LABEL")}
                                        onSelect={date => setEndDate(date)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={classNames("containerControls")}>
                            <Waiter
                                useClass={classNames("btn", "confirm")}
                                type={WAITER_TYPES.button}
                                handleOnClick={handleOnSaveReport}
                                stopPropagation={true}
                                spanText={t("basic.OK_BUTTON")}
                            />
                            <button
                                className={classNames("btn", "denied", "btnCancel")}
                                onClick={() => setIsOpen(false)}
                            >
                                {t("basic.CANCEL_BUTTON")}
                            </button>
                        </div>
                    </div>

                </div>
            }
        />
    )
}

export default ReportModalDateRange;